import { j as e } from "../../../jsx-runtime-B6kdoens.js";
import { a as c } from "../../../index-CROKJrb5.js";
import { c as x, f as n } from "../../../create-component-CBAeEoQ6.js";
import { Typography as r } from "../../Typography/index.js";
const z = x(
  "CardPricing",
  n(
    ({
      className: t,
      price: d,
      salePrice: l,
      salePriceSubscription: m,
      subscription: a,
      ...o
    }, s) => {
      if (l === void 0)
        return /* @__PURE__ */ e.jsxs("div", { className: c("cur-flex", t), ...o, children: [
          /* @__PURE__ */ e.jsx(r, { ref: s, size: "meta", weight: "bold", children: d }),
          a && /* @__PURE__ */ e.jsxs(r, { ref: s, size: "meta", children: [
            "/",
            a
          ] })
        ] });
      const i = m !== void 0 ? m : a;
      return /* @__PURE__ */ e.jsxs("div", { className: c("cur-flex", t), ...o, children: [
        /* @__PURE__ */ e.jsx(r, { ref: s, size: "meta", weight: "bold", children: l }),
        i !== "" && i && /* @__PURE__ */ e.jsxs(r, { ref: s, size: "meta", children: [
          "/",
          i
        ] }),
        /* @__PURE__ */ e.jsx(
          r,
          {
            as: "s",
            role: "deletion",
            className: "cur-ml-1 cur-text-disabled cur-line-through",
            ref: s,
            size: "meta",
            children: d
          }
        ),
        a && /* @__PURE__ */ e.jsxs(r, { ref: s, size: "meta", className: "cur-text-disabled", children: [
          "/",
          a
        ] })
      ] });
    }
  )
);
export {
  z as CardPricing
};
//# sourceMappingURL=index.js.map
